export const UA_THEME_VARS = 'ua-variables' as const;
export const INTERFACE_THEME = 'interface-theme' as const;
export const UA_INTERFACE_ENABLE_HOVER_EFFECT = 'ua_interface_enable_hover_effect ' as const;
export const NAVIGATION_CONTAINER_PREVIEW = 'navigation-container-preview' as const;
